export default 'https://tme.understood.org/assets/background.37cf5a7e.glb'